import React, { useContext } from 'react'
import useRouter from 'utils/useRouter'
import { ListItemIcon, ListItemText } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import AddCommentIcon from '@material-ui/icons/AddComment'
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned'

import { DetalhesCasoContext } from '../../DetalhesCasoContext'
import { StyledMenu, StyledMenuItem } from './MenuAcoes.styles'

export const MenuAcoes = (props) => {
  const { anchorEl, onClose, id, setOpenEspelhoImportarObjetos } = props
  const router = useRouter()
  const context = useContext(DetalhesCasoContext)

  if (!context || !context.caso) return null

  const dados = context.caso

  const handleClickBotaoEditar = () => {
    router.history.push(`/casos/caso/editar/${dados.id}`)
  }

  const handleClickAdicionarInformacao = async () => {
    router.history.push(`/caso/adicionarInformacao/${dados.id}`)
  }

  const handleClickImportarObjetos = async () => {
    setOpenEspelhoImportarObjetos(true)
    onClose()
  }

  return (
    <StyledMenu id={id} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={onClose}>
      <StyledMenuItem onClick={handleClickBotaoEditar}>
        <ListItemIcon>
          <EditIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Editar</ListItemText>
      </StyledMenuItem>
      <StyledMenuItem onClick={handleClickAdicionarInformacao}>
        <ListItemIcon>
          <AddCommentIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Adicionar Informação</ListItemText>
      </StyledMenuItem>
      <StyledMenuItem onClick={handleClickImportarObjetos}>
        <ListItemIcon>
          <AssignmentReturnedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Importar objetos</ListItemText>
      </StyledMenuItem>
    </StyledMenu>
  )
}
